/**
 * RendererContext — the engine-owned resolved runtime state published once by
 * BuilderEngine and read by the renderers: resolved theme, locale, asset resolver,
 * section registry, and config.
 */
import { createContext } from 'react'
import type { WebsiteLocale } from '../schema'
import type { AssetResolver } from './assets/assetResolver'
import type { RuntimeTheme } from './types'
import type { SectionRegistry, RuntimeConfig } from './types'

export interface RendererContextValue {
  readonly theme: RuntimeTheme
  readonly locale: WebsiteLocale
  readonly assets: AssetResolver
  readonly registry: SectionRegistry
  readonly config: RuntimeConfig
}

export const RendererContext = createContext<RendererContextValue | null>(null)
